import { render, staticRenderFns } from "./MissionList.vue?vue&type=template&id=670cd9c0&"
import script from "./MissionList.vue?vue&type=script&lang=js&"
export * from "./MissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports